// Decimal offsets source: https://developers.facebook.com/docs/marketing-api/currencies/
export const standardDecimalOffset = 100;
export const specialDecimalOffsets = {
    CLP: 1,
    COP: 1,
    CRC: 1,
    HUF: 1,
    ISK: 1,
    IDR: 1,
    JPY: 1,
    KRW: 1,
    PYG: 1,
    TWD: 1,
    VND: 1,
};
//# sourceMappingURL=currency.js.map